import { render, staticRenderFns } from "./InventoryLastReceivedReport.vue?vue&type=template&id=2b2b3274"
import script from "./InventoryLastReceivedReport.vue?vue&type=script&lang=js"
export * from "./InventoryLastReceivedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports